import { render } from "./ChangeLoader.vue?vue&type=template&id=40c14578&scoped=true"
import script from "./ChangeLoader.vue?vue&type=script&lang=js"
export * from "./ChangeLoader.vue?vue&type=script&lang=js"

import "./ChangeLoader.vue?vue&type=style&index=0&id=40c14578&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40c14578"]])

export default __exports__